import { css, styled } from "styled-components";

type Props = {
  $variant: "primary" | "secondary";
  $size: "medium" | "large";
};

export const ButtonContainer = styled.button<Props>`
  flex-direction: row;
  justify-content: center;
  align-items: center;

  &:disabled {
    opacity: 0.4;
  }

  &:focus {
    outline: solid #d0e8ff;
  }

  ${({ $variant }) => {
    switch ($variant) {
      case "primary":
        return css`
          background-color: ${(props) => props.theme.colors.vividBlue};
          color: ${(props) => props.theme.colors.white};

          &:not(:disabled):hover {
            background-color: #0065c4;
          }
        `;
      case "secondary":
        return css`
          background-color: ${(props) => props.theme.colors.white};
          color: ${(props) => props.theme.colors.black};

          &:not(:disabled):hover {
            color: ${({ theme }) => theme.colors.vividBlue};
          }
        `;
    }
  }};

  ${({ $size, theme }) => {
    switch ($size) {
      case "medium":
        return css`
          border-radius: 24px;
          padding: 11px 20px;
          ${theme.typography.bodyText.b4impactbold}
          letter-spacing: 0;
        `;
      case "large":
        return css`
          border-radius: 28px;
          padding: 13px 20px;
          ${theme.typography.bodyText.b3bold}
        `;
    }
  }};
`;
